var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"pa-7 rounded-lg",attrs:{"color":"","outlined":""},on:{"click":function($event){return _vm.AuthProvider('github')}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-github")]),_vm._v(" Sign in with Github ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }